import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { SubscriptionResponse } from '../models/response/SubscriptionResponse';

@Injectable({
    providedIn: 'root'
})
export class HttpSubscriptionService {

    private baseApiUrl = this.trimTrailingSlash(environment.subscriptionApi.uri);

    constructor(
        private http: HttpClient
    ) { }

    getUserLicence(): Observable<SubscriptionResponse> {
        const url = `${this.baseApiUrl}/user-license-and-signatures`;
        return this.http.get<SubscriptionResponse>(url);
    }

    trimTrailingSlash(url: string): string {
        return url.endsWith('/') ? url.slice(0, -1) : url;
    }
}
